<div class="goods">
  <div class="row expanded items-center head-category">
    <div class="column breadcrumb">
      <div class="breadcrumb-inner">
      <a (click)="backToHeadCategories()">{{ headCategoryName }}</a>
      <span>{{ subHeadCategoryName }}</span>
      <p>{{ headCategoryNameColored }}</p>
      </div>
    </div>

    <div class="column shrink vertical-line">
      <a class="menu-brands">
        <span class="ico" (click)="brandsMenuShow()">
          <img *ngIf="headCategoryNameColored" src="/assets/images/icons/mobile_menu_catalog.svg">
        </span>
      </a>
    </div>

    <div class="users-admin-list" *ngIf="allowLoginUsers && allowLoginUsers.length && activeOrganization && activeOrganization.type === 'fiz'">
      <ng-select (change)="changeUser()" [(ngModel)]="selectedUser">
        <ng-option [value]="0">Користувач не вибраний</ng-option>
        <ng-option *ngFor="let user of allowLoginUsers" [value]="user.email">{{ user.fio }} <br> ({{ user.email }})
        </ng-option>
      </ng-select>
    </div>

    <div class="users-admin-list" *ngIf="isAdmin && userListAdmin && activeOrganization && activeOrganization.type === 'fiz'">
      <ng-select (change)="adminUserSelected()" [(ngModel)]="selectedUserAdmin">
        <ng-option [value]="0">Користувач не вибраний</ng-option>
        <ng-option *ngFor="let user of userListAdmin" [value]="user.id">{{ user.fio }} <br> ({{ user.email }})
        </ng-option>
      </ng-select>
    </div>

    <div class="users-admin-list" *ngIf="switchOrganizations.length > 1">
      <ng-select (change)="changeOrganization()" [(ngModel)]="selectedOrganizationId">
        <ng-option *ngFor="let org of switchOrganizations" [value]="org.id">{{ org.name }}</ng-option>
      </ng-select>
    </div>

    <div class="column shrink dop-filters size-dop-filters" *ngIf="activeOrganization && activeOrganization.type === 'fiz' && showPartnerWarehouses">
      <div class="btn-wrap-line">
        <label class="label-checkbox" [class.active]="includePartners" (click)="includePartnersCheckbox()">
          Партнерські склади
        </label>
      </div>
    </div>

    <div class="column shrink dop-filters size-dop-filters">
      <div class="btn-wrap-line">
        <label class="label-checkbox" [class.active]="haveGoodsCheckbox" (click)="availabilityCheckbox()">
          Наявність товару
        </label>
      </div>
    </div>

    <div class="column shrink size-dop-filters desktop">
      <div class="btn-dropdown-delivery btn-wrap-line" *ngIf="deliveryCurrent">
        <button class="button change-delivery-method">
          Вибір доставки, складу<small>{{ deliveryCurrent.name }}{{ warName }}</small>
        </button>
        <div class="list-dels" [class.hide]="isMenuNpClose">
          <ul>
            <li class="active" *ngFor="let delivery of deliveryInfo" (click)="setDelivery(delivery.id)">
              <b>{{ delivery.name }}</b>
              <p [innerHTML]="delivery.comment"></p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="column shrink user-icon size-favorites" routerLink="/orders_history_new">
      <i class="fa fa-solid fa-user"></i>
    </div>

    <a routerLink="/basket" class="column shrink basket size-favorites">
      <span class="count-goods">{{ basketCount }} товар(-а)</span>
      <span class="summa-basket" *ngIf="basketSum > 0">{{ basketSum }} {{ currencyName }}</span>
      <span class="summa-basket" *ngIf="basketSum <= 0">0.00 {{ currencyName }}</span>
    </a>
  </div>

  <div class="column shrink size-dop-filters mobile">
    <div class="delivery-row-mobile">
      <div class="btn-dropdown-delivery">
        <button class="button change-delivery-method" *ngIf="deliveryCurrent" (click)="showDelivery()">
          Вибір доставки, складу<small>{{ deliveryCurrent.name }}{{ warName }}</small>
        </button>
        <span class="logo-np"
              *ngIf="deliveryCurrent && deliveryCurrent.id == 1 && !isAdmin && !userListAdmin && !allowLoginUsers">
          <img src="/assets/images/icons/delicons/1.png">
        </span>
        <span class="logo-np"
              *ngIf="deliveryCurrent && deliveryCurrent.id == 2 && !isAdmin && !userListAdmin && !allowLoginUsers">
          <img src="/assets/images/icons/delicons/2.png">
        </span>
        <span class="logo-np"
              *ngIf="deliveryCurrent && deliveryCurrent.id == 3 && !isAdmin && !userListAdmin && !allowLoginUsers">
         <img src="/assets/images/icons/delicons/3.png">
        </span>
        <span class="logo-np"
              *ngIf="deliveryCurrent && deliveryCurrent.id == 5 && !isAdmin && !userListAdmin && !allowLoginUsers">
          <img src="/assets/images/icons/delicons/5.png">
        </span>
        <span class="logo-np"
              *ngIf="deliveryCurrent && deliveryCurrent.id == 7 && !isAdmin && !userListAdmin && !allowLoginUsers">
          <img src="/assets/images/icons/delicons/9.png">
        </span>
        <span class="logo-np"
              *ngIf="deliveryCurrent && deliveryCurrent.id == 8 && !isAdmin && !userListAdmin && !allowLoginUsers">
          <img src="/assets/images/icons/delicons/7.png">
        </span>
        <span class="logo-np"
              *ngIf="deliveryCurrent && deliveryCurrent.id == 9 && !isAdmin && !userListAdmin && !allowLoginUsers">
          <img src="/assets/images/icons/delicons/8.png">
        </span>
        <div class="list-dels" [class.show]="showMobileDelivery">
          <ul>
            <li class="active" *ngFor="let delivery of deliveryInfo" (click)="setDelivery(delivery.id)">
              <b>{{ delivery.name }}</b>
              <p [innerHTML]="delivery.comment"></p>
            </li>
          </ul>
        </div>
      </div>

      <div class="mobile-selects">
        <div class="users-admin-list-mobile" *ngIf="allowLoginUsers && allowLoginUsers.length && activeOrganization && activeOrganization.type === 'fiz'">
          <ng-select (change)="changeUser()" [(ngModel)]="selectedUser">
            <ng-option [value]="0">Користувач не вибраний</ng-option>
            <ng-option *ngFor="let user of allowLoginUsers" [value]="user.email">{{ user.fio }} <br> ({{ user.email }})
            </ng-option>
          </ng-select>
        </div>

        <div class="users-admin-list-mobile" *ngIf="isAdmin && userListAdmin && activeOrganization && activeOrganization.type === 'fiz'">
          <ng-select (change)="adminUserSelected()" [(ngModel)]="selectedUserAdmin">
            <ng-option [value]="0">Користувач не вибраний</ng-option>
            <ng-option *ngFor="let user of userListAdmin" [value]="user.id">{{ user.fio }} {{ user.email }}</ng-option>
          </ng-select>
        </div>

        <div class="users-admin-list-mobile" *ngIf="switchOrganizations.length > 1">
          <ng-select (change)="changeOrganization()" [(ngModel)]="selectedOrganizationId">
            <ng-option *ngFor="let org of switchOrganizations" [value]="org.id">{{ org.name }}</ng-option>
          </ng-select>
        </div>
      </div>
    </div>
  </div>

  <div class="column shrink size-dop-filters mobile">
    <div class="btn-filter">
      <div class="column shrink dop-filters size-dop-filters-mobile" *ngIf="activeOrganization && activeOrganization.type === 'fiz' && showPartnerWarehouses">
        <div class="btn-wrap-line-filter">
          <label class="label-checkbox" [class.active]="includePartners" (click)="includePartnersCheckbox()">
            Партнерські склади
          </label>
        </div>
      </div>

      <div class="column shrink dop-filters size-dop-filters-mobile">
        <div class="btn-wrap-line-filter">
          <label class="label-checkbox" [class.active]="haveGoodsCheckbox" (click)="availabilityCheckbox()">
            Наявність товару
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

